import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';

import IUser from '@/interfaces/user';

declare let gtag: (command: string, commandOrValue: any | string, value?: any) => void;

interface IStateUser {
  user: IUser | null;
}

const initialState: IStateUser = {
  user: null
};
export const authSlice = createSlice({
  name: 'authSlice',
  initialState,
  reducers: {
    setUser(state, user: PayloadAction<IUser>) {
      if (user?.payload) addUserContext(user.payload);
      return {
        ...state,
        user: user.payload
      };
    }
  }
});

function addUserContext(user: IUser) {
  Sentry.setUser({
    email: user.email,
    id: String(user.id),
    username: user.name,
    type: user.type,
    is_support: user.is_support,
    support_id: user.support_id
  });
  gtag('set', {
    user_id: user?.id,
    nxp: true,
    type: user?.type,
    is_support: user?.is_support,
    support_id: user?.support_id
  });
}

export const { setUser } = authSlice.actions;

export default authSlice.reducer;
